import { useMemo } from "react";
import {jwtDecode} from "jwt-decode";

export function useDecodedToken() {
  const token = localStorage.getItem("token"); // adapt to your storage
  return useMemo(() => {
    if (!token) return null;
    
    try {
      return jwtDecode(token);
    } catch {
      return null;
    }
  }, [token]);
}
